const ROLE_STORE = 'UT_HEAVENLIGHT_USERS_STORE_ALL';
const ROLE_OFFICE = 'UT_HEAVENLIGHT_USERS_OFFICE_ALL';
const ROLE_PERSONAL_SHOPPER = 'UT_HEAVENLIGHT_USERS_PERSONALSHOPPER_ALL';
const ROLE_FENDI_INTERNET_USER = 'UT_HEAVENLIGHT_USERS_INTERNET_ALL';


export default {
  ROLE_STORE,
  ROLE_OFFICE,
  ROLE_PERSONAL_SHOPPER,
  ROLE_FENDI_INTERNET_USER,

  COMPANY_CORPORATE: 'FENDI CORPORATE',
  COMPANY_EUROPE: 'FENDI EUROPE',
  COMPANY_MEI: 'FENDI MEI',
  COMPANY_JAPAN: 'FENDI JAPAN',
  COMPANY_CHINA: 'FENDI CHINA',
  COMPANY_AMERICAS: 'FENDI AMERICAS',
  COMPANY_APAC: 'FENDI APAC',

  STORE_FALLBACK: {
    1021: 1018,
    1056: 1018,
    1077: 1083,
    1091: 1083,
    1121: 1123,
    1141: 1123,
    1149: 1123,
    1193: 1201,
    1198: 1201,
    1203: 1201,
    1216: 1228,
    1232: 1255,
    1420: 1179,
    1478: 1041,
  },

  ERROR: {
    GENERIC: {
      message: 'Access Denied.',
      error: 'Your user does not have access to this application.',
    },
    STORE_NOT_FOUND: {
      message: 'Store not found in Retail Master Data',
      error: extensionAttributeValue => `Error code 'extensionAttribute1': ${extensionAttributeValue}`,
    },
    MISSING_STORE: {
      message: 'Incorrect Store configuration',
      error: 'Missing \'extensionAttribute1\'',
    },
    INTERNET_ROLE: {
      message: 'Incorrect User configuration',
      error: `Your user does not have permission to access the site from outside the Fendi network. Missing role:\n${ROLE_FENDI_INTERNET_USER}`,
    },
    UNKNOWN_ROLE: {
      message: 'Incorrect User configuration',
      error: `Your user does not have one of the required permissions\n Required permissions:\n${[
        ROLE_STORE,
        ROLE_OFFICE,
        ROLE_PERSONAL_SHOPPER,
      ].join('\n')}`,
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/core/auth/auth.constant.js